import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const Cart = ({ color, fill = 'transparent', ...props }) => (
  <IconBase viewBox='0 0 20 20' {...props}>
    <Path
      d='
          M16.3144 18.1753C16.0876 18.1753 15.9022 18.3589
           15.9058 18.5875C15.9058 18.8143 16.0894 18.9997
           16.318 18.9997C16.5466 18.9997 16.7302 18.8161 16.7302
           18.5875C16.7266 18.3589 16.5412 18.1753 16.3144 18.1753
        '
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='
          M6.85044 18.1753C6.62364 18.1753 6.43825 18.3589 6.44185
          18.5875C6.44005 18.8143 6.62544 18.9997 6.85224 18.9997C7.07904
          18.9997 7.26444 18.8161 7.26444 18.5875C7.26444 18.3589 7.07904
          18.1753 6.85044 18.1753'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='
        M3.67508 4.37496H17.8787C18.6113 4.37496 19.1477 5.06255 18.9695
        5.77354L17.4539 11.8395C17.2235 12.7611 16.4405 13.4379 15.4955
        13.5333L7.82763 14.3C6.68464 14.4134 5.63885 13.6503 5.40306 12.5271L2.94428
        1H1.00391'
      stroke={color}
      fill={fill}
      fillRule='evenodd'
      clipRule='evenodd'
    />
    <Path
      d='
        M3.67508 4.37496H17.8787C18.6113 4.37496 19.1477 5.06255 18.9695
        5.77354L17.4539 11.8395C17.2235 12.7611 16.4405 13.4379 15.4955
        13.5333L7.82763 14.3C6.68464 14.4134 5.63885 13.6503 5.40306 12.5271L2.94428 1H1.00391'
      stroke={color}
      fill={fill}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Cart.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Cart
